var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover",style:(("--cover-gap: var(--s" + _vm.gap + "); --cover-height: " + _vm.height + ";"))},[_vm._t("header"),_c('div',{staticClass:"centered"},[_vm._t("default")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }